import { useBreakpointValue } from "@chakra-ui/react";

// ref: https://chakra-ui.com/docs/styled-system/theme#breakpoints
const MD_BREAKPOINT = 48 * 16;
const isInitiallyCollapsed = window.innerWidth < MD_BREAKPOINT;
const fallback = isInitiallyCollapsed ? "sm" : "md";

const defaultValues = { base: true, xl: false };
const arg = { fallback };

type Values = Partial<Record<string, boolean>> | boolean[];

export const useIsCollapsed = (values?: Values): boolean => {
  const breakpointMap = values || defaultValues;

  return useBreakpointValue(breakpointMap, arg) ?? isInitiallyCollapsed;
};
